export * from "./mapLeagueUrl"